<template>
  <div
    class="step-wrapper"
    :class="{
      'step-wrapper--with-gap': withGap,
      'step-wrapper--with-error': hasError,
      'step-wrapper--borderless': borderless
    }"
  >
    <div class="step-wrapper__header">
      <div class="step-wrapper__header-left">
        <StepNumber
          v-if="!borderless"
          :compact="borderless"
          :step-number="stepNumber"
          :content="headerText"
        ></StepNumber>
        <slot name="header-badge"></slot>
      </div>
      <slot name="step-number-content"></slot>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import StepNumber from "./StepNumber.vue";

export default {
  name: "StepWrapper",
  components: { StepNumber },
  props: {
    stepNumber: {
      type: Number,
      default: 1
    },
    headerText: {
      type: String,
      default: undefined
    },
    withGap: {
      type: Boolean,
      default: false
    },
    hasError: {
      type: Boolean,
      default: false
    },
    borderless: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
@import "frontend/init/jiffy/settings.scss";

.step-wrapper {
  $this: &;

  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  border: 1px solid $gray-border;
  padding: 10px 15px 15px 15px;
  border-radius: 8px;
  box-shadow: 0px 25px 30px 0px rgba($black, 0.05);
  background-color: $white;

  &--borderless {
    border: none;
    border-radius: 0;
    box-shadow: none;
    padding: 0;

    #{$this}__header {
      justify-content: flex-end;
    }
  }

  &--with-gap {
    gap: 10px;
  }

  &--with-error {
    border-color: $red-border;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    &-left {
      display: flex;
      align-items: center;
      gap: 12px;
      flex: 1;

      @media (max-width: 767px) {
        flex-wrap: wrap;
      }
    }
  }
}
</style>
